module.exports = __webpack_public_path__ + "img/sRickyTyco_193x205.9974b3d8.png";